export const SpecialOfferPopup = {
  el: {
    links: document.querySelectorAll<HTMLElement>('a[href]'),
    popups: document.querySelectorAll<HTMLElement>('.special-offer-popup'),
  },

  init: () => {
    SpecialOfferPopup.el.popups.forEach((popup) => {
      SpecialOfferPopup.handlePopup(popup)
    })
  },

  handlePopup(popup): void {
    const popupName = popup.dataset.id
      ? `specialOfferPopup${popup.dataset.id}`
      : 'specialOfferPopup'

    const triggers = popup.querySelectorAll(
      '.special-offer-popup__button, .special-offer-popup__close-button'
    )

    const method = {
      closeOnEscPress(event): void {
        if (event.key.match('Escape') && method.isVisible()) {
          method.hidePopup()
          window.removeEventListener('keydown', method.closeOnEscPress)
        }
      },

      closeOnOutsideClick(event): void {
        if (
          !event.target.closest('.special-offer-popup') &&
          !event.target.closest('.ch2') &&
          method.isVisible()
        ) {
          method.hidePopup()
          document.body.removeEventListener('click', method.closeOnOutsideClick)
        }
      },

      hidePopup(): void {
        popup.classList.remove('special-offer-popup--visible')
        setTimeout(() => {
          popup.remove()
          sessionStorage.setItem(popupName, 'disabled')
        }, 321)
      },

      isVisible(): boolean {
        return popup.classList.contains('special-offer-popup--visible')
      },
    }

    if (sessionStorage.getItem(popupName) === 'disabled') {
      if (!popup) {
        return
      }
      popup.remove()
      return
    } else {
      popup.classList.add('special-offer-popup--visible')
      SpecialOfferPopup.el.links.forEach((link) => {
        link.addEventListener('click', method.hidePopup)
      })
      triggers.forEach((trigger) => {
        trigger.addEventListener('click', method.hidePopup)
      })
      document.body.addEventListener('click', method.closeOnOutsideClick)
      window.addEventListener('keydown', method.closeOnEscPress)
    }
  },
}
